import React from 'react'

export interface TagTypeProps {
    type: string;
}

const TAG_STYLE = {
    task: {label: "Neu", bg: "#E8F5E9", fg: "#008000"},
    //verbessert: { label: "Verbessert", bg: "#E1F0FA", fg: "#0288D1" },
    bugfix: {label: "Behoben", bg: "#FFEBEE", fg: "#E53935"},
};

export function TypeTag({type}: TagTypeProps) {

    const t = TAG_STYLE[type] || TAG_STYLE.task;

    return (
        <span style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center", height: 20, padding: "0 8px",
            borderRadius: 3, background: t.bg, color: t.fg, fontSize: 11, fontWeight: 500,
            letterSpacing: ".02em", textTransform: "uppercase",
        }}>{t.label}</span>
    )
}